import * as types from '@/constants/mutationTypes'
import {sidebarTabs} from '@/constants/sidebarTabs'

const state = {
  activeTab: sidebarTabs[0].id
}
const getters = {
  activeTab: state => state.activeTab
}
const actions = {
  setActiveTab ({commit}, data) {
    commit(types.SET_ACTIVE_TAB, {data})
  }
}
const mutations = {
  [types.SET_ACTIVE_TAB] (state, {data}) {
    state.activeTab = data
  }}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/ActiveTab/modules/store.js